import { ChangeDetectionStrategy, Component, Optional, input, model } from '@angular/core';
import { TranslocoDirective } from '@ngneat/transloco';
import { UntilDestroy } from '@ngneat/until-destroy';
import { InputTextComponent } from '@pedix-workspace/angular-ui-form-reactive';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';

@UntilDestroy()
@Component({
  selector: 'pxw-end-order-customer-fields',
  templateUrl: './end-order-customer-fields.component.html',
  styleUrls: ['./end-order-customer-fields.component.scss'],
  providers: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, InputTextComponent, FormsModule],
  viewProviders: [
    {
      provide: ControlContainer,
      deps: [[Optional, NgForm]],
      useFactory: (ngForm: NgForm) => ngForm,
    },
  ],
})
export class EndOrderCustomerFieldsComponent {
  readonly isFormSubmitted = input<boolean>(false);
  readonly personalInformationFieldsRequired = input<boolean>(false);

  readonly name = model.required<string | null>();
  readonly phone = model.required<string | null>();

  protected charactersAndSpacePattern = /^[A-Za-zÁÉÍÓÚÜáéíóúüñÑ0-9 ]+$/;
}
